import { Button } from "../components/ui/button";
import SiteLayout from "../components/SiteLayout";
import { products, services, servicesPricingNote } from "../data/siteContent";

const WorkPage = () => {
  return (
    <SiteLayout>
      <div className="page-shell" data-testid="work-page">
        <section className="product-grid product-grid--work-simple">
          <div>
            <div className="eyebrow stagger-1" data-testid="work-page-eyebrow">
              Services & Products
            </div>
            <h1 className="page-title stagger-2" data-testid="work-page-title">
              Our Work
            </h1>
            <p className="page-intro stagger-3" data-testid="work-page-intro">
              Hailo Digital provides custom software development and AI development services to business clients, alongside the platforms it builds.
            </p>
          </div>

          <div className="services-grid stagger-4" data-testid="work-services-grid">
            {services.map((service, index) => (
              <article
                className="section-card service-card"
                data-testid={`work-service-card-${index + 1}`}
                key={service.name}
              >
                <div className="section-label" data-testid={`work-service-label-${index + 1}`}>
                  Service
                </div>
                <h2 className="section-heading" data-testid={`work-service-name-${index + 1}`}>
                  {service.name}
                </h2>
                <p className="section-copy" data-testid={`work-service-description-${index + 1}`}>
                  {service.description}
                </p>
              </article>
            ))}
          </div>

          <p className="page-intro stagger-4" data-testid="work-services-pricing-note">
            {servicesPricingNote}
          </p>

          <div className="products-grid stagger-4" data-testid="work-products-grid">
            {products.map((product, index) => (
              <article
                className="product-card product-card--feature product-card--minimal"
                data-testid={`work-product-card-${product.name.toLowerCase().replace(/\s+/g, "-")}`}
                key={product.name}
              >
                <div className="product-label" data-testid={`work-product-label-${index + 1}`}>
                  Product
                </div>
                <h2 className="product-title" data-testid={`work-product-title-${index + 1}`}>
                  {product.name}
                </h2>
                <p className="product-description" data-testid={`work-product-description-${index + 1}`}>
                  {product.description}
                </p>

                <div className="product-link">
                  <Button
                    asChild
                    className="primary-button"
                    data-testid={`work-product-cta-${index + 1}`}
                    size="lg"
                  >
                    <a href={product.url} rel="noreferrer" target="_blank">
                      {product.ctaLabel}
                    </a>
                  </Button>
                </div>
              </article>
            ))}
          </div>

          <article className="future-card future-card--minimal stagger-4" data-testid="work-future-panel">
            <div className="panel-label" data-testid="work-future-panel-label">
              Future Products
            </div>
          </article>
        </section>
      </div>
    </SiteLayout>
  );
};

export default WorkPage;
